import { computed, shallowRef } from '@vue/composition-api';
import type { SObject } from '@/types';
import type {
  RecordId,
  CompareOverviewRecord,
} from '@/services/SalesforceService';
import { immutableSlice } from '@/util';

type SelectedRecord = CompareOverviewRecord;

const selected = shallowRef<SelectedRecord[]>([]);

export default function useSelected() {
  function getBySObject(sobject: SObject) {
    return selected.value.filter((item) => item.SObject === sobject);
  }

  function add(item: SelectedRecord) {
    selected.value = [...selected.value, item];
  }

  function remove(id: RecordId) {
    selected.value = selected.value.filter((i) => i.Id !== id);
  }

  function reset() {
    selected.value = [];
  }

  const ids = computed(() => selected.value.map((record) => record.Id));

  function isInSelected(id: RecordId) {
    return ids.value.includes(id);
  }

  function isNotInSelected(id: RecordId) {
    return isInSelected(id) === false;
  }

  function update(id: RecordId, updatedItem: SelectedRecord): void {
    const index = selected.value.findIndex((item) => item.Id === id);
    if (index === -1) {
      return;
    }
    selected.value = immutableSlice(selected.value, index, updatedItem);
  }

  return {
    selected,
    ids,
    getBySObject,
    add,
    update,
    remove,
    reset,
    isInSelected,
    isNotInSelected,
  };
}
